import * as types from 'store/modules/hres89u/mutation-types'
import hres89u from 'api/hres89u'
import swal from 'sweetalert'
import hres89uLabels from 'assets/labels/hres89u'
import { hres89uColumns } from 'assets/columns/hres89u'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import * as dashTypes from 'store/modules/dash/mutation-types'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres89uLabels,
    columns: hres89uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {}
    },
    dropdowns: {
      codemprc: {
        en: {},
        th: {}
      }
    },
    approve: {},
    indexSelected: [],
    detailSubmit: {
      tab1: {}
    }
  },
  getters: {
    [types.GET_HRES89U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES89U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES89U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES89U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES89U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES89U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES89U_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES89U_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRES89U_DETAIL_SUBMIT] (state) {
      return state.detailSubmit
    }
  },
  mutations: {
    [types.SET_HRES89U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES89U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES89U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES89U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES89U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES89U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES89U_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRES89U_DETAIL_SUBMIT] (state, data) {
      state.detailSubmit = data
    },
    [types.SET_HRES89U_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    }
  },
  actions: {
    [types.TOGGLE_HRES89U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES89U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES89U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES89U_COLUMNS_LABELS] ({ commit }) {
      hres89u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES89U_COLUMNS, data.labels)
          commit(types.SET_HRES89U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES89U_INDEX] ({ commit }, searchParams) {
      hres89u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES89U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES89U_DETAIL] ({ commit }, detailParams) {
      hres89u.getDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES89U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES89U_DROPDOWNS] ({ commit }) {
      hres89u.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES89U_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES89U_DETAIL_SUBMIT] ({ commit }, detailParams) {
      hres89u.getDetailSubmit(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES89U_DETAIL_SUBMIT, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES89U_SEND_APPROVE] ({ commit, dispatch }, params) {
      let referenceButton = params.referenceButton
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      hres89u.postSendApprove(params.approveParams)
      .then((response) => {
        const data = JSON.parse(response.request.response)
        dispatch(types.RECEIVED_HRES89U_INDEX, {})
        dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
        swal({title: '', text: data.response, html: true, type: 'success'}, function () {
          referenceButton.click()
        })
      })
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres89u/index.js